import { functions } from '../firebase/firebase';
import { httpsCallable } from 'firebase/functions';

// Points to the rs-genkit Firebase Function deployed as 'chatWithFinancialAssistant'
const chatFn = httpsCallable(functions, 'chatWithFinancialAssistant', {
  timeout: 120000, // 120 seconds — agent chains can take time
});

/**
 * Sends a chat message to the financial AI assistant.
 * @param {string} question - The user's question
 * @param {string|null} sessionId - Optional session ID for conversation continuity
 * @returns {Promise<{answer: string, agentsUsed: string[], sources: object, sessionId: string}>}
 */
export const sendChatMessage = async (question, sessionId = null) => {
  const payload = { question };
  if (sessionId) payload.sessionId = sessionId;

  const result = await chatFn(payload);
  return result.data;
};
